"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 22px;\n  height: 37px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n"], ["\n  display: flex;\n  align-items: center;\n  width: 22px;\n  height: 37px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

var _buoyTheme2 = _interopRequireDefault(_buoyTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.button.withConfig({
  displayName: "BurgerIcon__Container",
  componentId: "sc-11rev3t-0"
})(_templateObject);

var BurgerIcon = function BurgerIcon(_ref) {
  var color = _ref.color,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    Container,
    { onClick: onClick },
    _react2.default.createElement(
      "svg",
      {
        width: "22px",
        height: "17px",
        viewBox: "0 0 22 17",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg" },
      _react2.default.createElement(
        "g",
        {
          stroke: "none",
          strokeWidth: "1",
          fill: "none",
          fillRule: "evenodd",
          strokeLinecap: "round" },
        _react2.default.createElement(
          "g",
          {
            transform: "translate(-283.000000, -14.000000)",
            stroke: _buoyTheme2.default.colors[color],
            strokeWidth: "1.5" },
          _react2.default.createElement(
            "g",
            { transform: "translate(284.000000, 15.000000)" },
            _react2.default.createElement("path", { d: "M0,0.5 L20,0.5" }),
            _react2.default.createElement("path", { d: "M0,7.5 L20,7.5" }),
            _react2.default.createElement("path", { d: "M0,14.5 L20,14.5" })
          )
        )
      )
    )
  );
};

BurgerIcon.propTypes = {
  color: _propTypes2.default.string,
  onClick: _propTypes2.default.func.isRequired
};

BurgerIcon.defaultProps = {
  color: "white"
};

exports.default = BurgerIcon;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-icons/dist/icons/BurgerIcon.js
// module id = 414
// module chunks = 168707334958949